import React from "react";

const PendingApproval = () => {
  return (
    <div
      className="size-12 flex items-center justify-center rounded-lg object-cover ring-1 ring-gray-900/10 text-gray-500 text-sm bg-blue-100"
      style={{ width: "50px", height: "50px" }} // Adjust size as needed
    >
     <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-sky-300 bg-sky-600"></div>
    </div>
  );
};

export default PendingApproval;
